module.exports = __webpack_public_path__ + "media/images/alarm-clock-11e4258f5a004f3e6aa257b68fdf6734.svg";